export default __webpack_public_path__ + "static/media/recordNum.0c577066.png";